import { create } from "zustand";
import { IFeedModules } from "@/common/api/services/types";

interface IFeedsModulesState {
  modules?: IFeedModules;
  expireAt?: number;
  loading: boolean;
  setFeedsModules: (modules: IFeedModules) => void;
  setExpireAt: (expireAt: number) => void;
  setLoading: (value: boolean) => void;
}

export const useFeedsModulesStore = create<IFeedsModulesState>(
  (set) => ({
    error: false,
    loading: false,
    setFeedsModules: (modules: IFeedModules) => set(() => ({ modules })),
    setExpireAt: (expireAt: number) => set(() => ({ expireAt })),
    setLoading: (loading: boolean) => set(() => ({ loading })),
  }),
);
